import { useMemo } from 'react';

const MESSAGES = [
  'Pondering...',
  'Mulling...',
  'Cogitating...',
  'Ruminating...',
  'Musing...',
  'Deliberating...',
  'Puzzling...',
  'Brewing...',
  'Percolating...',
  'Marinating...',
  'Simmering...',
  'Stewing...',
  'Whisking...',
  'Whirring...',
  'Crunching...',
  'Wrangling...',
  'Noodling...',
  'Tinkering...',
  'Fiddling...',
  'Rummaging...',
  'Conjuring...',
  'Concocting...',
  'Hatching...',
  'Scheming...',
  'Reticulating...',
];

const pickMessage = () => MESSAGES[Math.floor(Math.random() * MESSAGES.length)];

const Loader = ({ message }) => {
  const fallback = useMemo(() => pickMessage(), []);

  return (
    <div className="border rounded shadow-sm p-3">
      <small className="text-accent d-flex align-items-center">
        <i
          aria-hidden="true"
          style={{ fontSize: '0.75rem' }}
          className="fas fa-spinner fa-spin me-2"
        ></i>
        <span>{message || fallback}</span>
      </small>
    </div>
  );
};

export default Loader;
